/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

declare global {
  interface Window {
    newrelic: { noticeError: (error: string) => void };
  }
}

export const getCsrfToken = (): string | null => {
  const meta = document.head.querySelector('meta[name="_csrf"]');
  if (!meta) {
    return '';
  }
  return meta.getAttribute('content');
};

export const getCsrfTokenParameter = (): string | null => {
  const meta = document.head.querySelector('meta[name="_csrf_parameter"]');
  if (!meta) {
    return '';
  }
  return meta.getAttribute('content');
};

export const logCriticalError = (msg: string, exception: unknown): void => {
  window.newrelic?.noticeError(`${msg}. Exception: ${exception}`);

  console.error(`${msg}. Exception: ${exception}`);
  console.error(exception);
};
